<template>
  <!-- 导航 -->
  <div></div>
</template>

<script>
export default {
  props: ['active'],
  inject: ['reload'],
  data() {
    return {
      current: 0,
      menuList: [],
      loginDialog: false,
      loginForm: {
        loginName: '',
        pass: ''
      },

      loginRules: {
        loginName: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        pass: [{ required: true, message: '请输入登录密码', trigger: 'blur' }]
      },
      modifyDialog: false,
      modifyForm: {
        oldPwd: '',
        newPwd: ''
      },
      modifyRules: {
        oldPwd: [{ required: true, message: '请输入原登录密码', trigger: 'blur' }],
        newPwd: [{ required: true, message: '请输入新登录密码', trigger: 'blur' }]
      },
      cityList: [],
      city: ''
    }
  },
  created() {
    this.toggleNav()

    console.log(12)
  },
  updated() {},
  methods: {
    async submitLoginForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          var params = new URLSearchParams()
          params.append('loginName', this.loginForm.loginName) // 你要传给后台的参数值 key/value
          params.append('password', this.loginForm.pass)
          const { data } = await this.$http.request({
            url: '/erp4open_api/auction/loginForApp',
            method: 'post',
            data: params,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          })
          if (data.success) {
            this.$store.commit('setToken', data.data.token)
            this.loginDialog = false
            this.getUserInfo(data.data.token)
            this.$message({
              message: '恭喜您登录成功',
              type: 'success'
            })
          } else {
            this.$message.error(data.message)
          }
        } else {
          this.$message.error('用户名或者密码错误')
        }
      })
    },
    toggleNav() {
      this.current = this.active
    },

    login(cb) {
      this.loginDialog = true
    },
    resetLoginForm(formName) {
      this.$refs[formName].resetFields()
    },
    // 退出和修改
    handleCommand(command) {
      if (command === 'a') {
        this.modify()
      } else if (command === 'b') {
        this.quit()
      }
    },
    modify() {
      this.modifyDialog = true
    },
    async submitModifyForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          var params = new URLSearchParams()
          params.append('token', this.$store.state.token) // 你要传给后台的参数值 key/value
          params.append('oldPwd', this.modifyForm.oldPwd)
          params.append('newPwd', this.modifyForm.newPwd)
          const { data } = await this.$http.request({
            url: '/erp4open_api/auction/changePwd',
            method: 'post',
            data: params,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          })
          if (data.success) {
            this.modifyDialog = false
            this.$message({
              message: '密码修改成功',
              type: 'success'
            })
            this.reload()
          } else {
            this.$message.error(data.message)
          }
        } else {
          this.$message.error('原密码错误')
        }
      })
    },
    resetModifyForm(formName) {
      this.$refs[formName].resetFields()
    },
    quit() {
      this.$confirm('此操作将退出账号, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store.commit('quit')
          this.$message({
            type: 'success',
            message: '退出成功!'
          })
          this.reload()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消退出'
          })
        })
    }
  }
}
</script>

<style lang="less" scoped></style>
